<script>
    import { onMount } from "svelte";
    import * as api from "../stores/memoMng.store";
    import Menu from "../components/Menu.svelte";
    import Header from "../components/Header.svelte";

    export let params;
    let rcvord_no = params.no;

    let dvyfg_de = "";
    let print_rm = "";
    let rm = "";
    let rm2 = "";
    let rm3 = "";
    let rm4 = "";
    let rm5 = "";
    let rm6 = "";
    let rm7 = "";
    let rm8 = "";
    let memo = "";

    onMount(() => {
        getMemoMngDetail();
    });

    async function getMemoMngDetail() {
        const response = await api.apiGetMemoMngDetail(rcvord_no);

        dvyfg_de = response.dvyfg_de;
        print_rm = response.print_rm;

        rm = response.rm ?? "";
        rm2 = response.rm2 ?? "";
        rm3 = response.rm3 ?? "";
        rm4 = response.rm4 ?? "";
        rm5 = response.rm5 ?? "";
        rm6 = response.rm6 ?? "";
        rm7 = response.rm7 ?? "";
        rm8 = response.rm8 ?? "";
        memo = response.memo ?? "";
    }

    async function putMemoMng() {
        if (await api.apiPutMemoMng(rcvord_no, dvyfg_de, memo)) {
            alert("수정되었습니다.");
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<div>
    <Header title="스케쥴 상세" background_color="#a2474b" />

    <Menu />

    <div class="main main-sub main-sub-dtl">
        <div class="main-dtl-in">
            <p class="main-dtl-title">납기일자</p>
            <input type="date" class="in-date" bind:value={dvyfg_de} />
        </div>
        <div class="main-dtl-in">
            <p class="main-dtl-title">메모</p>
            <textarea class="in-date" style="height: 75px;" bind:value={memo}
            ></textarea>
        </div>
        <div class="main-dtl-in main-dtl-in-scroll scroll-custom">
            <p class="main-dtl-title">수주내역</p>
            <div class="main-dtl-inner">
                <p class="inner-title">수주번호</p>
                <p class="inner-contents">{rcvord_no}</p>
            </div>
            <div class="main-dtl-inner">
                <p class="inner-title">영업특이사항</p>
                <p class="inner-contents" style="white-space: normal;">
                    {print_rm}
                </p>
            </div>
            <div class="main-dtl-inner">
                <p class="inner-title">작업특이사항</p>
                {#if rm != ""}
                    <p
                        class="inner-contents inner-contents-bcnc"
                        style="white-space: normal;"
                    >
                        {rm}
                    </p>
                {/if}{#if rm2 != ""}
                    <p
                        class="inner-contents inner-contents-bcnc"
                        style="white-space: normal;"
                    >
                        {rm2}
                    </p>
                {/if}{#if rm3 != ""}
                    <p
                        class="inner-contents inner-contents-bcnc"
                        style="white-space: normal;"
                    >
                        {rm3}
                    </p>
                {/if}{#if rm4 != ""}
                    <p
                        class="inner-contents inner-contents-bcnc"
                        style="white-space: normal;"
                    >
                        {rm4}
                    </p>
                {/if}{#if rm5 != ""}
                    <p
                        class="inner-contents inner-contents-bcnc"
                        style="white-space: normal;"
                    >
                        {rm5}
                    </p>
                {/if}{#if rm6 != ""}
                    <p
                        class="inner-contents inner-contents-bcnc"
                        style="white-space: normal;"
                    >
                        {rm6}
                    </p>
                {/if}
                {#if rm7 != ""}
                    <p
                        class="inner-contents inner-contents-bcnc"
                        style="white-space: normal;"
                    >
                        {rm7}
                    </p>
                {/if}
                {#if rm8 != ""}
                    <p
                        class="inner-contents inner-contents-bcnc"
                        style="white-space: normal;"
                    >
                        {rm8}
                    </p>
                {/if}
            </div>
        </div>
        <div class="btn-wrap">
            <p class="btn-save" on:click={putMemoMng}>저장</p>
            <p
                class="btn-cancel"
                on:click={() => {
                    history.back();
                }}
            >
                취소
            </p>
        </div>
    </div>
</div>
